export default __webpack_public_path__ + "static/media/researchGif.85217d78.gif";